import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";

const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

export const StyledButton = styled.button`
  padding: 10px;
  border-radius: 50px;
  border: none;
  background-color: var(--secondary);
  padding: 10px;
  font-weight: bold;
  color: var(--secondary-text);
  width: 100px;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const StyledBuyButton = styled.button`
  padding: 10px;
  border-radius: 50px;
  border: none;
  background-color: #EC5800;
  padding: 10px;
  font-weight: bold;
  color: var(--secondary-text);
  width: 100px;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const StyledRoundButton = styled.button`
  padding: 20px;
  border-radius: 100%;
  border: none;
  background-color: var(--primary);
  padding: 10px;
  font-weight: bold;
  font-size: 15px;
  color: var(--accent-text);
  width: 50px;
  height: 50px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;

export const StyledLogo = styled.img`
  width: 500px;
  @media (min-width: 767px) {
    width: 800px;
  }
  position: relative;
  top: -24px;
  transition: width 0.5s;
  transition: height 0.5s;
`;

export const StyledImg = styled.img`
  box-shadow: 0px 5px 11px 2px rgba(0, 0, 0, 0.7);
  background-color: var(--accent);
  width: 200px;
  @media (min-width: 900px) {
    width: 250px;
  }
  @media (min-width: 1000px) {
    width: 300px;
  }
  transition: width 0.5s;
`;

export const StyledLink = styled.a`
  color: var(--secondary);
  text-decoration: none;
`;

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`Click mint to claim your NFT.`);
  const [paidMintCount, setPaidMintCount] = useState(0);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "0x523f61bdeda519385757c592ab9bb37835cc0b90",
    SCAN_LINK: "https://etherscan.com/address/0x523f61bdeda519385757c592ab9bb37835cc0b90",
    NETWORK: {
      NAME: "Ethereum",
      SYMBOL: "ETH",
      ID: 1,
    },
    NFT_NAME: "FRANK n BRAINz",
    SYMBOL: "FNBZ",
    BASE_GAS_LIMIT: 120000,
    PER_GAS_LIMIT: 12000,
    MARKETPLACE: "OpenSea",
    MARKETPLACE_LINK: "https://opensea.io/collection/frank-n-brainz",
    SHOW_BACKGROUND: true,
  });

  
  const claimNFTs = () => {
    let perGasLimit = CONFIG.PER_GAS_LIMIT;
    let baseGasLimit = CONFIG.BASE_GAS_LIMIT;
    if((data.merkleRoot.toString('hex')) != ("0x" + data.calculatedRoot.toString('hex'))) {
      setFeedback(`Merkle root mismatch between contract and dApp, please try again later.`);
      setClaimingNft(false);
      return;
    }
    if((data.maxClaim <= data.claimed) && paidMintCount == 0) {
      setFeedback(`You have no FRANK n BRAINz available to claim and none set to purchase.`);
      setClaimingNft(false);
      return;
    }
    let totalGasLimit = String(perGasLimit * (data.maxClaim - data.claimed + paidMintCount) + baseGasLimit);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    
    if(data.maxClaim <= data.claimed && data.publicMintOpen) {
      try { 
        console.log(data.merkleProof);
        blockchain.smartContract.methods
          .mint(paidMintCount)
          .send({
            gasLimit: String(totalGasLimit),
            to: CONFIG.CONTRACT_ADDRESS,
            from: blockchain.account,
            value: (data.publicMintPrice * paidMintCount),
          })
          .once("error", (err) => {
            console.log(err);
            setFeedback("Sorry, something went wrong please try again later.");
            setClaimingNft(false);
          })
          .then((receipt) => {
            console.log(receipt);
            setFeedback(
              `The ${CONFIG.NFT_NAME} is yours! Visit OpenSea.io to view it.`
            );
            setClaimingNft(false);
            dispatch(fetchData(blockchain.account));
          });
        } catch (err) {
          console.log(err);
          setFeedback("Sorry, something went wrong please try again later.");
          setClaimingNft(false);
        }
    } else {
      try { 
        console.log(data.merkleProof);
        blockchain.smartContract.methods
          .claim(paidMintCount, data.maxClaim, data.merkleProof)
          .send({
            gasLimit: String(totalGasLimit),
            to: CONFIG.CONTRACT_ADDRESS,
            from: blockchain.account,
            value: (data.publicMintPrice * paidMintCount),
          })
          .once("error", (err) => {
            console.log(err);
            setFeedback("Sorry, something went wrong please try again later.");
            setClaimingNft(false);
          })
          .then((receipt) => {
            console.log(receipt);
            setFeedback(
              `The ${CONFIG.NFT_NAME} is yours! Visit OpenSea.io to view it.`
            );
            setClaimingNft(false);
            dispatch(fetchData(blockchain.account));
          });
        } catch (err) {
          console.log(err);
          setFeedback("Sorry, something went wrong please try again later.");
          setClaimingNft(false);
        }
    }
  };

  const verifyPaidMintCount = (target) => {
    var newPaidMintCount = 1;
    try {
      newPaidMintCount = parseInt(target.value);
      if(isNaN(newPaidMintCount)) { newPaidMintCount = 1; }
      if(newPaidMintCount > 100) { newPaidMintCount = 100; }
      if(newPaidMintCount < 0) { newPaidMintCount = 0; }
      if(data.maxClaim > 0) {
        if(newPaidMintCount > (5000-data.totalSupply)) { newPaidMintCount = 5000-data.totalSupply;}
      } else {
        if(!data.publicMintOpen) { newPaidMintCount = 0; }
        else if(newPaidMintCount > (5000-data.totalSupply-data.holderReserve)) { newPaidMintCount = (5000-data.totalSupply-data.holderReserve); }

        if(newPaidMintCount < 0) { newPaidMintCount = 0; }
      }
    } catch(err) {}
    setPaidMintCount(newPaidMintCount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
    getData();
  }, [blockchain.account]);

  return (
    <s.Screen>
      <s.Container
        flex={1}
        ai={"center"}
        style={{ padding: 24, backgroundColor: "var(--primary)" }}
        image={"/config/images/grunge.png"}
      >
        <StyledLogo alt={"logo"} src={"/config/images/logo.png"} />
        <ResponsiveWrapper flex={1} style={{ padding: 24 }} test>
          <s.SpacerLarge />
          <s.Container
            flex={2}
            jc={"center"}
            ai={"center"}
            style={{
              backgroundColor: "var(--accent)",
              padding: 24,
              border: "4px var(--secondary)",
              boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)",
            }}
          >
            <StyledImg src={"/images/featured.png"} />
            <s.SpacerMedium />
            <s.TextDescription
              style={{
                textAlign: "center",
                color: "var(--primary-text)",
              }}
            >
             Contract Address: <StyledLink target={"_blank"} href={CONFIG.SCAN_LINK}>
                {truncate(CONFIG.CONTRACT_ADDRESS, 15)}
              </StyledLink>
            </s.TextDescription>
            <s.SpacerSmall />
            { ((blockchain.account === "" ||
                blockchain.smartContract === null)) ? <>
                  <s.Container ai={"center"} jc={"center"}>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      Connect to the {CONFIG.NETWORK.NAME} network
                    </s.TextDescription>
                    <s.SpacerSmall />
                    <StyledButton
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(connect());
                        getData();
                      }}
                    >
                      CONNECT
                    </StyledButton>
                    {blockchain.errorMsg !== "" ? (
                      <>
                        <s.SpacerSmall />
                        <s.TextDescription
                          style={{
                            textAlign: "center",
                            color: "var(--accent-text)",
                          }}
                        >
                          {blockchain.errorMsg}
                        </s.TextDescription>
                      </>
                    ) : null}
                  </s.Container></> : <>
                <s.TextTitle
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  {(data.maxClaim > 0) ? 
                    <>FRANK n BRAINz available: {1313-data.totalSupply}</> : 
                    <>FRANK n BRAINz available: {(1313-data.totalSupply) < 0 || !data.publicMintOpen ? 0 : 1313-data.totalSupply}</>
                  }
                </s.TextTitle>
                <s.SpacerXSmall />
                <s.TextTitle
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  {(data.maxClaim > 0) ? 
                    <>You are eligible for {data.maxClaim} free FRANK n BRAINz and have claimed {data.claimed}.</> : 
                    <></>
                  }
                </s.TextTitle>
                <s.SpacerXSmall />
                <s.TextTitle
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  {(data.maxClaim > data.claimed) ? 
                    <>Additional FRANK n BRAINz cost 0.00666E each.</> : 
                    <>FRANK n BRAINz cost 0.00666E each.</>
                  }
                </s.TextTitle>
                <s.SpacerXSmall />
                <s.TextDescription
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  Excluding gas fees.
                </s.TextDescription>
                <s.SpacerLarge />
                {data.maxClaim > data.claimed ? 
                  <>
                    <s.TextDescription style={{fontSize: "20px"}}>
                      Claim: {data.maxClaim - data.claimed} Free FRANK n BRAINz
                    </s.TextDescription>
                    <s.SpacerXSmall />
                  </> :
                  <></>
                }
                <s.TextDescription style={{fontSize: "20px"}}>
                  Purchase: <input type="text" style={{marginLeft: "5px", marginRight: "5px", fontSize: "20px", width: "100px", textAlign: "center"}} value={paidMintCount} onChange={(e) => { verifyPaidMintCount(e.target);}} /> FRANK n BRAINz
                </s.TextDescription>
                {blockchain.account === "" ||
                blockchain.smartContract === null ? (<></>
                ) : (
                  <>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      {feedback}
                    </s.TextDescription>
                    <s.SpacerMedium />
                    
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                      <StyledButton
                        disabled={claimingNft  ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          claimNFTs();
                          getData();
                        }}
                      >
                        {claimingNft ? "BUSY" : "MINT"}
                      </StyledButton>
                    </s.Container>
                    <s.SpacerSmall />
                    <s.TextDescription style={{fontSize: "15px"}}>
                      Cost: {paidMintCount * data.publicMintPrice / 10**18} ETH
                    </s.TextDescription>
                  </>
                )}
              </> }
            <s.SpacerMedium />
          </s.Container>
          <s.SpacerLarge />
        </ResponsiveWrapper>
        <s.SpacerMedium />
      </s.Container>
    </s.Screen>
  );
}

export default App;
